import { InputForm, SubmitButton, Error } from "components";
import { CreateUserFormError, CreateUserProps } from "modules/auth/users/store/actionType";
import { fetchAllRoles } from '../../../../role/store/action';
import { connect } from 'react-redux';
import {useEffect} from 'react';
import MultiSelectForm from '../../../../../../components/form/MultiSelectionForm';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: CreateUserProps;
  handleChange: (
   event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  error: CreateUserFormError;
  loading: boolean;
  header: string;
}
const CreateUserForm: React.FC<Props> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header,
  fetchAllRoles,
  onFetchRoles
}) => {

useEffect(() => {
    onFetchRoles();
  }, [onFetchRoles]);
const roles = fetchAllRoles?.roles || [];

  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <InputForm
              label="Full Name"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {error.name && <Error>{error.name}</Error>}
          </div>
          <div>
            <InputForm
              label="Mobile No."
              type="text"
              id="mobile_no"
              name="mobile_no"
              value={formData.mobile_no}
              onChange={handleChange}
            />
            {error.mobile_no && <Error>{error.mobile_no}</Error>}
          </div>
          <div>
            <InputForm
              label="Email"
              id="email"
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {error.email && <Error>{error.email}</Error>}
          </div>
          <div>
            <MultiSelectForm
              label="Roles"
              id="roles"
              name="roles"
              value={formData.role_ids}
              option={roles}
              onChange={(selected) =>
                handleChange({
                  target: { name: "role_ids", value: selected },
                } as any)
              } 
            />
            {error.role_ids && <Error>{error.role_ids}</Error>}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <InputForm
              label="Password"
              type="text"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {error.password && <Error>{error.password}</Error>}
          </div>
          <div>
            <InputForm
              label="Confirm Password"
              type="text"
              id="confirm_password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
            />
            {error.confirm_password && <Error>{error.confirm_password}</Error>}
          </div>{" "}
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};


const mapStateToProps = (state: any) => {
  return {
    fetchAllRoles: state.roles?.fetchRolesState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchRoles: () => dispatch(fetchAllRoles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserForm);
